import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  appConfig,
  Firebase,
  isDevelopment
} from './../../util';

class AssessmentLogin extends Component {

  state = {
    email: '',
    password: '',
    loginError: null,
    loginMessage: null,
    syncingWithServer: false,
    resettingPassword: false,
    resetPasswordComplete: false
  }

  handleSubmit(event){
    event.preventDefault();
    this.submitLoginForm();
  }

  getLoginButtonHtml(){
    return {
      __html: (this.state.syncingWithServer ? 'Logging in...' : 'Login')
    };
  }

  getResetPasswordButtonHtml(){
    return {
      __html: (this.state.syncingWithServer ? 'Resetting...' : 'Reset password')
    };
  }

  toggleResettingPassword(){
    this.setState({
      resettingPassword: !this.state.resettingPassword,
    });
  }

  submitLoginForm(){

    this.setState({
      syncingWithServer: true,
      loginError: false
    });

    const {email, password} = this.state;

    Firebase.auth().signInWithEmailAndPassword(email, password).catch(error => {
      this.setState({
        syncingWithServer: false,
        loginError: error.message,
      });
    }).then(() => {
      console.log('firebase signin THEN!');
      // this.setState({
      //   redirectToReferrer: true,
      // });
    });
  }

  submitResetPasswordForm(){
    this.setState({
      syncingWithServer: true,
      loginError: false
    });

    const {email} = this.state;

    Firebase.auth().sendPasswordResetEmail(email, {
      url: `${appConfig().APP_URL}/login?email=${encodeURIComponent(email)}`,
    }).then(() => {
      this.setState({
        resettingPassword: false,
        logingError: null,
        syncingWithServer: false,
        password: '',
        loginMessage: 'Password reset. Check your email.',
        resetPasswordComplete: true,
      })
    }).catch(error => {
      this.setState({
        syncingWithServer: false,
        loginError: error.message
      });
    });
  }

  renderLoginForm(){

    const {
      email,
      password,
      syncingWithServer,
      loginError,
      loginMessage,
      resettingPassword,
      resetPasswordComplete
    } = this.state;

    return (
      <form onSubmit={this.handleSubmit.bind(this)}>
        <div className="velocity-form page-form">
          {!resetPasswordComplete &&
            <h2>{resettingPassword ? 'Reset Password' : 'Login'}</h2>
          }
          {isDevelopment() && !resetPasswordComplete && !resettingPassword &&
            <template style={{marginBottom: '20px'}}>
              <h6 style={{color: '#545B72', marginTop: '0px', marginBottom:'5px'}}>QUICK LOGIN (DEVELOPMENT ONLY)</h6>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('new'); }} className="button grey-outline button-micro">New Assessment</button>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('inprogress'); }} className="button grey-outline button-micro">In Progress Assessment</button>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('completed'); }} className="button grey-outline button-micro">Completed Assessment</button>
            </template>
          }
          {loginError &&
            <div className="form-message error">{loginError}</div>
          }
          {loginMessage &&
            <div className="form-message success">{loginMessage}</div>
          }
          {!resetPasswordComplete &&
            <div className="form-group">
              <label htmlFor="velocity-login-email">Email</label>
              <input ref={input => { this.emailInput = input; }} id="velocity-login-email" disabled={syncingWithServer} type="text" placeholder="Email" value={email} onChange={(e) => this.setState({ email: e.target.value }) } />
            </div>
          }
          {!resettingPassword && !resetPasswordComplete &&
            <div className="form-group">
              <label htmlFor="velocity-login-password">Password</label>
              <input ref={input => { this.passwordInput = input; }} id="velocity-login-password" disabled={syncingWithServer} type="password" placeholder="Password" value={password} onChange={(e) => this.setState({ password: e.target.value }) } />
            </div>
          }
          {!resettingPassword && !resetPasswordComplete &&
            <div className="form-group">
              <button className={'button primary' + (syncingWithServer ? ' disabled' : '')} disabled={syncingWithServer} onClick={this.submitLoginForm.bind(this)} dangerouslySetInnerHTML={this.getLoginButtonHtml()}></button>
            </div>
          }
          {resettingPassword && !resetPasswordComplete &&
            <div className="form-group">
              <button className={'button primary' + (syncingWithServer ? ' disabled' : '')} disabled={syncingWithServer} onClick={this.submitResetPasswordForm.bind(this)} dangerouslySetInnerHTML={this.getResetPasswordButtonHtml()}></button>
            </div>
          }
          {!resetPasswordComplete &&
            <div className="form-group">
              <p className="forgot-password actionable centered" onClick={this.toggleResettingPassword.bind(this)}>{resettingPassword ? 'Cancel' : 'Forgot password?'}</p>
            </div>
          }
          {!resettingPassword &&
            <div className="form-group">
              <p className="forgot-password actionable centered" onClick={this.props.showSignupForm}>Create a new account...</p>
            </div>
          }
        </div>
      </form>
    )
  }

  render(){
    return (
      <div className="page login">
        {this.renderLoginForm()}
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps, {})(AssessmentLogin);



// WEBPACK FOOTER //
// ./src/components/takeAssessment/assessmentLogin.js